export default function copyToClipboard(copyText) {
	const temporaryInput = document.createElement('textarea')
	temporaryInput.value = copyText
	document.body.appendChild(temporaryInput)
	temporaryInput.select()
	document.execCommand('copy')
	document.body.removeChild(temporaryInput)
}